export const DATE_PLACEHOLDER = 'DD/MM/YYYY';
export const TIME_PLACEHOLDER = 'HH:mm';
